import type { Resource } from "permissions/resources/permission-resource";
import type { AnyResourceJSON } from "./types";

type Factory = (json: AnyResourceJSON) => Resource;
const registry = new Map<string, Factory>();

export function registerResource(type: string, factory: Factory) {
  registry.set(type, factory);
}

export function resourceFromJSON(json: AnyResourceJSON) {
  const factory = registry.get(json.resourceType);
  if (!factory) throw new Error(`Unknown resource type: ${json.resourceType}`);
  return factory(json);
}
